import { WidgetDataSource } from 'app/models';
import { AnalysisGroup } from 'app/providers/storage-api/analysis-group-service';
import { Analysis } from 'app/providers/storage-api/analysis.service';
import { CalculationListItem } from 'app/providers/storage-api/predictive.service';

//TODO: make the version a global value somewhere
//For now when changing, update the version number and update the reference in
//update datasource method in dashboard-view.component.
export class WidgetAnalysisDataSource extends WidgetDataSource {
  constructor(analysis: Analysis) {
    super();
    this.id = analysis.name;
    this.analysisId = analysis.name;
    this.displayName = analysis.displayName;
    this.type = 'analysis';
    this.collectionName = analysis.collectionName;
    this.groupCollections = undefined;
    this.modifiedAt = analysis.modifiedAt;
    this.createdAt = analysis.createdAt;
    this.groupId = undefined;
    this.groupAnalyses = undefined;
    this.hasDateData = analysis.hasDateData;
    this.hasTaxonomy = analysis.hasTaxonomy;
    this.entityTypes = analysis.entityTypes;
    this.topicTypes = analysis.topicTypes;
    this.documentCount = analysis.documentCount;
    this.hasEntities = analysis.hasEntities;
    this.hasPhrases = analysis.hasPhrases;
    this.hasThemes = analysis.hasThemes;
    this.hasTopics = analysis.hasTopics;
    this.hasTopicMentions = analysis.hasTopicMentions;
    this.hasTopicPhrases = analysis.hasTopicPhrases;
    this.hasTopicThemes = analysis.hasTopicThemes;
    this.hasThemeMentions = analysis.hasThemeMentions;
    this.hasEntityMentions = analysis.hasEntityMentions;
    this.hasEntityPhrases = analysis.hasEntityPhrases;
    this.customFields = analysis.customFields;
    this.standardFields = analysis.standardFields;
    this.version = 9;
    this.sourceVersion = analysis.sourceVersion ? analysis.sourceVersion : 1;
    this.minDocAt = analysis.minDocAt != null ? new Date(analysis.minDocAt) : null;
    this.maxDocAt = analysis.maxDocAt != null ? new Date(analysis.maxDocAt) : null;
    this.isFinished = analysis.status === 'IDLE';
    this.clauseModelTypes = analysis.clauseModelTypes;
    this.configId = analysis.configId;
    this.configName = analysis.configName;
    this.notes = analysis.notes;
    this.isSocial = analysis.isSocial;
    this.objectLabels = analysis.objectLabels;
    this.hasSectionSentiment = analysis.hasSectionSentiment;
    this.sectionPropertyTypes = analysis.sectionPropertyTypes;
  }
}

export class WidgetAnalysisGroupDataSource extends WidgetDataSource {
  filterLookupId?: string;

  constructor(group: AnalysisGroup) {
    super();
    this.id = group.id;
    this.groupId = group.id;
    this.displayName = group.name;
    this.modifiedAt = group.modifiedAt;
    this.createdAt = group.createdAt;
    this.type = 'group';
    this.collectionName = undefined;
    this.groupCollections = group.analyses.map((an) => an['collectionName']);
    this.analysisId = undefined;
    this.groupAnalyses = group.analyses.map((an) => an['analysisName']);
    this.hasTaxonomy = group.hasTaxonomy;
    this.hasDateData = group.hasDateData;
    this.entityTypes = group.entityTypes;
    this.topicTypes = group.topicTypes;
    this.documentCount = 0;
    group.analyses.forEach((analysis: Analysis) => {
      this.documentCount += analysis.documentCount;
    });
    this.filterLookupId = group.lookupId;
    this.hasEntities = group.hasEntities;
    this.hasPhrases = group.hasPhrases;
    this.hasThemes = group.hasThemes;
    this.hasTopics = group.hasTopics;
    this.hasTopicMentions = group.hasTopicMentions;
    this.hasTopicPhrases = group.hasTopicPhrases;
    this.hasTopicThemes = group.hasTopicThemes;
    this.hasThemeMentions = group.hasThemeMentions;
    this.hasEntityMentions = group.hasEntityMentions;
    this.hasEntityPhrases = group.hasEntityPhrases;
    this.customFields = group.customFields;
    this.standardFields = group.standardFields;
    this.version = 9;
    this.sourceVersion = group.sourceVersion ? group.sourceVersion : 1;
    this.minDocAt = group.minDocAt != null ? new Date(group.minDocAt) : null;
    this.maxDocAt = group.maxDocAt != null ? new Date(group.maxDocAt) : null;
    this.isFinished = true;
    this.clauseModelTypes = group.clauseModelTypes;
    this.hasSections = group.hasSections;
    this.sectionFieldNames = group.sectionFieldNames;
    this.objectLabels = group.objectLabels;
    this.hasSectionSentiment = group.hasSectionSentiment;
    this.sectionPropertyTypes = group.sectionPropertyTypes;
    this.isJourneyGroup = group.journeyGroupRule !== null;
    this.journeyGroupRule = group.journeyGroupRule;
  }
}

export class WidgetKeyDriverAnalysisDataSource extends WidgetDataSource {
  static forEach(_arg0: (kda: any) => string[]) {
    throw new Error('Method not implemented.');
  }
  constructor(calculation: CalculationListItem) {
    super();
    this.id = calculation.id;
    this.analysisId = calculation.id;
    this.displayName = calculation.displayName;
    this.type = 'analysis';
    this.collectionName = calculation.collectionId;
    this.groupCollections = undefined;
    this.modifiedAt = new Date(calculation.createdAt);
    this.createdAt = new Date(calculation.createdAt);
    this.groupId = undefined;
    this.groupAnalyses = undefined;
    this.hasDateData = true;
    this.tags = calculation.tags;
    this.isFinished = calculation.status === 'IDLE';
    this.sourceVersion = 7;
    this.customFields = [];
    this.standardFields = [];
    this.documentCount = calculation.documentCount;
    this.query = calculation.query;
    this.objectLabels = calculation.objectLabels;
  }
}
